import { createSlice } from "@reduxjs/toolkit";
import { getProfile, getToken, setProfile } from "../utils/localStorage";

export const user = createSlice({
  name: "user",
  initialState: {
    isAuthorized: getToken() ? true : false,
    profile: getProfile(),
  },
  reducers: {
    signin: (state) => {
      state.isAuthorized = getToken() ? true : false;
      state.profile = getProfile();
    },

    updateProfileDetails: (state, action) => {
      setProfile({ ...getProfile(), ...action.payload });
      state.profile = { ...getProfile(), ...action.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const { signin, updateProfileDetails } = user.actions;

export default user.reducer;
